import { render } from "./PointImage.vue?vue&type=template&id=b6043014"
const script = {}
script.render = render

export default script